<template>
  <svg 
    :width="width" 
    :height="height" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
  >
    <ellipse cx="10" cy="10.8333" rx="7.5" ry="7.5" :stroke="color" stroke-width="1.5"/>
    <path d="M10 7.5V10.5657C10 10.7329 10.0836 10.889 10.2226 10.9818L12.5 12.5" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M14.1665 1.66667L17.4998 4.16667" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M10 1.66667L10 3.33333" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M14.1665 17.5L14.9998 19.1667" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M5.8335 17.5L5.00016 19.1667" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M5.8335 1.66667L2.50016 4.16667" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'AlarmIcon',
  props: {
    width: {
      type: [String, Number],
      default: 20
    },
    height: {
      type: [String, Number],
      default: 20
    },
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#78350F'
    }
  }
}
</script>
